/**
 * Get products related by color for product ids of related products
 * @param  {array}  list of related products
 * @param  {object} tile info for shop the look product
 * @return {array}  list of product IDs related by color
 */
export function getRelatedProductsByColor(relatedProducts, tileInfo) {
    if (relatedProducts) {
        return relatedProducts.reduce((accumulator, item, index, arr) => {
            // Loop through all tiles and identify them on the SKU level with the product response
            _.forIn(tileInfo, (tile) => {
                // eslint-disable-next-line no-undefined
                const productByProductId = item.product.productId === tile.productId ? item.product : null;

                if (productByProductId) {
                    accumulator.push(
                        Object.assign({}, productByProductId, {
                            viewCode: tile.viewCode,
                            colorCode: tile.colorCode,
                            product: Object.assign({}, productByProductId.product, {
                                queryParams: `color=${tile.colorCode}&recommendation=rectray-shop-the-look`
                            })
                        })
                    );
                }
            });

            return accumulator;
        }, []);
    }
    return [];
}

/**
 * Get product info for items with related products to color
 * @param  {array}  list of related products
 * @return {object}  object of product info for related products
 */
export function getProductInfoForRelatedProducts(itemsWithRelatedProductsToColor) {
    return itemsWithRelatedProductsToColor.reduce((accumulator, productInfo, index, arr) => {
                if (productInfo.productsRelatedToColor && productInfo.productsRelatedToColor.length > 0) {
                    productInfo.productsRelatedToColor.forEach((relatedProductInfo) => {
                        accumulator[`${relatedProductInfo.productId}_${relatedProductInfo.colorCode}`] = relatedProductInfo;
                    });
                }

                return accumulator;
            }, {});
}

/**
 * Get list of products from items with products related to color
 * @param  {array}  list of related products
 * @return {array}  list of related product ids
 */
export function getRelatedProductIdList(itemsWithRelatedProductsToColor) {
    return itemsWithRelatedProductsToColor.reduce((accumulator, item, index, arr) => {
                const relatedProducts = item.productsRelatedToColor;

                relatedProducts.forEach((product) => {
                    if (product.productId) {
                        accumulator.push(product.productId);
                    }
                });

                return accumulator;
            }, []);
}

export default {
    getRelatedProductsByColor: getRelatedProductsByColor,
    getProductInfoForRelatedProducts: getProductInfoForRelatedProducts,
    getRelatedProductIdList: getRelatedProductIdList
};

/**
 * Add shop-the-look query to a collection of products. Used for GA tracking the product category for rectray tiles.
 * product.product.queryParams is consumed by the macro _displayTile
 * @param  {object} products
 * @param  {string} strategyName Used for GA tracking of the product_category (pr1ca) parameter
 * @return {object} products
 */
export function setStrategyName(products) {
    return _.map(products, (p) => {
        _.set(p, 'product.queryParams', 'recommendation=rectray-shop-the-look');
        return p;
    });
}
